import {Button} from "react-aria-components";
import "./DefaultButton.css"
import React from "react";

function BaseButton({text, onPress, href, className, oneClick=false}: {text: string, onPress?: () => void, href?: string, className: string, oneClick: boolean}) {
  const [inProgress, setInProgress] = React.useState(false)

  if(onPress === undefined && href !== undefined) {
    onPress = () => {
      window.location.href = href
    }
  }

  if (oneClick) {
    const oldOnPress = onPress
    onPress = () => {
      setInProgress(true)
      if (oldOnPress === undefined) {
        setInProgress(false)
        return
      }
      if (oldOnPress instanceof Promise) {
        oldOnPress.finally(() => {
          setInProgress(false)
        })
        return
      } else {
        oldOnPress()
        setInProgress(false)
      }
    }
  }

  if(inProgress) {
    className += " pending"
  }
  return <Button
      className={className}
      onPress={onPress}
      isPending={inProgress}
  >
    {text}
  </Button>
}

function DefaultButton({text, onPress, href, className, oneClick} : {text: string, onPress?: any, href?: string, className?: string, oneClick?: boolean}) {
    return <BaseButton
        text={text}
        onPress={onPress}
        href={href}
        className={"defaultButton "+className}
        oneClick={oneClick}
    />
}

function SecondaryButton({text, onPress, href, className, oneClick}: {text: string, onPress?: never, href?: string, className?: string, oneClick?: boolean}) {
  return <BaseButton
      text={text}
      onPress={onPress}
      href={href}
      className={"secondaryButton "+className}
      oneClick={oneClick}
  />

}


function WarningButton({text, onPress, href, className, oneClick}: {
    text: string,
    onPress?: () => void,
    href?: string,
    className?: string,
    oneClick?: boolean
}) {
  return <BaseButton
      text={text}
      onPress={onPress}
      href={href}
      className={"warningButton "+className}
      oneClick={oneClick}
  />
}

export {SecondaryButton, WarningButton};
export default DefaultButton;